import { render, staticRenderFns } from "./cariara.vue?vue&type=template&id=0594f9d6"
import script from "./cariara.vue?vue&type=script&lang=js"
export * from "./cariara.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports